import { render, staticRenderFns } from "./MemberGroup.vue?vue&type=template&id=1ea2c80a"
import script from "./MemberGroup.vue?vue&type=script&lang=js"
export * from "./MemberGroup.vue?vue&type=script&lang=js"
import style0 from "./MemberGroup.vue?vue&type=style&index=0&id=1ea2c80a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports